import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
// import PopupLoginError from './LoginError';

function DeliveryStatusPopup({ isPopup, setIsPopup }) {
  const location = useLocation();
  const [popupActive, setPopupActive] = useState(false);
  // const [isPopupLoginError, setIsPopupLoginError] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isPopup ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isPopup]);

  useEffect(() => {
    let timeout;
    if (isPopup) {
      timeout = setTimeout(() => {
        setPopupActive(true);
      }, 100);
    } else {
      setPopupActive(false);
    }
    return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
    document.body.style.overflow = 'auto';
  }, [location]);

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);
  };

  const handleBackgroundClick = (e) => {
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };

  // const resetStates = () => {
  //   setIsPopupLoginError({
  //     message: '',
  //     action: ''
  //   });
  // };

  const handleConfirm = () => {
    // resetStates();
    setIsPopup(false);
  };

  if (!isPopup) return null;

  const deliveryData = [
    { date: '2025.06.16', time: '20:03', location: '김포우체국', status: '인수완료' },
    { date: '2025.06.16', time: '21:26', location: '부평물류센터', status: '발송' },
    { date: '2025.06.16', time: '22:05', location: '안양우편물류센터', status: '도착' },
    { date: '2025.06.17', time: '05:14', location: '서울동작우체국', status: '발송' },
    { date: '2025.06.17', time: '05:56', location: '서울동작우체국 TEL : 02.822.8385 길어져라', status: '배달준비 (집배원 정보 보기)' },
    { date: '2025.06.18', time: '08:04', location: '서울동작우체국', status: '배달완료 (수령인: 본인)' },
  ];
  return (
    <div className="popup-box-component" onClick={handleBackgroundClick}>
      <div className={`box content add ${popupActive ? 'active' : ''}`}>
        <div className="popup_container">
          <h4 className='pop_title line'>배송 진행상황</h4>
          <div className='close_btn_con'>
            <button className="close_btn" onClick={handleClose} />
          </div>
          <div className="delivery_table_wrap">

            <table className="delivery_table_web">
              <thead>
                <tr>
                  <th>날짜</th>
                  <th>시간</th>
                  <th>발생국</th>
                  <th>처리현황</th>
                </tr>
              </thead>
              <tbody>
                {deliveryData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.date}</td>
                    <td>{item.time}</td>
                    <td className='del_center'><p className='ellipsis_clamp' style={{maxWidth:'160px'}}>{item.location}</p></td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <ul className="delivery_table">
                <li>
                  <div className='staus_label'>
                    <span>날짜</span>
                  </div>
                  <div className='staus_info'>
                    <span>2025.06.16</span>
                  </div>
                </li>

                <li>
                  <div className='staus_label'>
                    <span>시간</span>
                  </div>
                  <div className='staus_info'>
                    <span>20:03</span>
                  </div>
                </li>
                <li>
                  <div className='staus_label'>
                    <span>발생국</span>
                  </div>
                  <div className='staus_info'>
                    <span>김포우체국</span>
                    <span>TEL : 02.822.8385</span>
                  </div>
                </li>
                <li>
                  <div className='staus_label'>
                    <span>처리현황</span>
                  </div>
                  <div className='staus_info'>
                    <span>배달준비</span>
                    <span>(집배원 정보 보기)</span>
                  </div>
                </li>
            </ul>
            
          </div>
          <div className='pop_btn_wrap'>
            <button 
              type="button"
              className="default_btn black pop_con_btn mt_16" 
              onClick={handleConfirm}
            >
              확인
            </button>
          </div>
        </div>
      </div>

      {/* <PopupLoginError 
        isPopup={isPopupLoginError} 
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      /> */}
    </div>
  );
};

export default DeliveryStatusPopup;
